export default {"src":"/_next/static/media/right-arrow.5ec13e72.svg","height":17,"width":8};